const xAxis = {
  height: 60,
  padding: { left: 70, right: 20 },
}

const yAxis = {
  width: 100,
}

export default {
  xAxis,
  yAxis,
}
